export const BRASS_AUTH_DENIED_MSG = "You don't have permissions to perform the task."
export const BRASS_ALLOWED_STATUS = "Allowed";